//############################################################################
// Object fit
//############################################################################

import objectFitImages from 'object-fit-images';
objectFitImages();
